import { getEnv } from '@rtvloco/platform/env';
/**
 * PIS Client Application Constants
 *
 * Centralizes all magic numbers and configuration constants.
 * Every value is typed and documented for auditability.
 */

/** Application display name */
export const APP_NAME = 'SMARTTT PIS' as const;

/** Application version — set at build time via VITE_APP_VERSION */
export const APP_VERSION: string =
  getEnv('VITE_APP_VERSION', '0.0.0-dev');

// ---------------------------------------------------------------------------
// Layout dimensions (pixels)
// ---------------------------------------------------------------------------

/** Sidebar width when fully expanded */
export const SIDEBAR_WIDTH_OPEN = 260;

/** Sidebar width in rail/collapsed mode */
export const SIDEBAR_WIDTH_RAIL = 60;

/** Right detail panel width */
export const RIGHT_PANEL_WIDTH = 320;

/** Minimum main content area width before sidebar collapses to rail */
export const MIN_CONTENT_WIDTH = 800;

// ---------------------------------------------------------------------------
// Polling & connectivity
// ---------------------------------------------------------------------------

/** Default polling interval for GraphQL queries (ms) */
export const POLL_INTERVAL_MS = 30_000;

/** WebSocket keepAlive ping interval (ms) */
export const WS_KEEPALIVE_MS = 30_000;

/** Token silent renew interval threshold (seconds) */
export const TOKEN_REFRESH_INTERVAL_S = 30;

/** Maximum retry attempts for WebSocket reconnection */
export const MAX_RETRY_ATTEMPTS = Infinity;

/** Initial backoff delay for retries (ms) */
export const RETRY_INITIAL_DELAY_MS = 1_000;

/** Maximum backoff delay for retries (ms) */
export const RETRY_MAX_DELAY_MS = 30_000;

// ---------------------------------------------------------------------------
// Pagination
// ---------------------------------------------------------------------------

/** Default page size for list views */
export const DEFAULT_PAGE_SIZE = 50;

/** Maximum page size allowed by the API */
export const MAX_PAGE_SIZE = 200;

// ---------------------------------------------------------------------------
// Storage keys
// ---------------------------------------------------------------------------

/** localStorage key for theme preference */
export const STORAGE_KEY_THEME = 'pis.theme';

/** localStorage key for locale preference */
export const STORAGE_KEY_LOCALE = 'pis.locale';

/** localStorage key for sidebar collapsed state */
export const STORAGE_KEY_SIDEBAR = 'pis.sidebar.collapsed';

// ---------------------------------------------------------------------------
// Date / Time formats
// ---------------------------------------------------------------------------

/** Date format for display (ISO 8601 date) */
export const DATE_FORMAT = 'yyyy-MM-dd';

/** Time format for display (HH:mm:ss) */
export const TIME_FORMAT = 'HH:mm:ss';

/** DateTime format for display */
export const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

// ---------------------------------------------------------------------------
// PIS-specific constants
// ---------------------------------------------------------------------------

/** Maximum text task message length (characters) */
export const MAX_TEXT_TASK_LENGTH = 4096;

/** Maximum audio announcement duration (seconds) */
export const MAX_AUDIO_DURATION_S = 120;

/** Number of departure rows to display by default */
export const DEFAULT_DEPARTURE_ROWS = 10;
